<template>
  <svg :class="'icon'" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path
      d="M13.5 15.75V11.25H15.75V15.75C15.75 16.9926 14.7426 18 13.5 18H2.25C1.00736 18 0 16.9926 0 15.75V4.5C0 3.25736 1.00736 2.25 2.25 2.25H4.5V4.5H2.25V15.75H13.5ZM12.6964 6.1875H10.9286C10.0446 6.1875 8.27679 6.1875 5.625 8.83929C5.625 5.30357 8.27679 2.65179 10.9286 2.65179H12.6964V0L18 4.41964L12.6964 8.83929V6.1875Z"
      :fill="color"
    />
  </svg>
</template>

<script setup>
defineProps({
  color: {
    type: String,
    default: '#000000',
  },
})
</script>

<style lang="scss" scoped></style>
